import common from '@/store/common/mutations';
import * as types from './mutation-types';
import moment from 'moment';

let startDate = moment().startOf('month').format('YYYY-MM-DD');
let endDate = moment().endOf('month').format('YYYY-MM-DD');

const getInit = () => {
	return {
		searchParams: {
			pmcId: '',
			pmcNo: '',
			flclSpc: '',
			saleRegn: '',
			carVin: '',
			carScn: '', //차량구분
			srchMm03: '',
			pwrType: '', //동력유형
			carTypeNm: '', 
			// strtMm01: startDate, //strtMm01
			// endMm01: endDate, //endMm01
			strtMm01: '', //strtMm01
			endMm01: '', //endMm01
			idxScn:'',
			licensePlate: ''
		},
		carSaleList: [],
		flclSpcList: [], //검색 연료전지사양 셀렉트박스
		carScnList: [], //검색 차량구분 셀렉트박스
		companySaleList: [], //검색 판매일 셀렉스박스
		saleRegnList: [], //검색 판매지역 셀렉트박스
		prcsStepList: [], //조회조건 처리단계
		gridPrcStepList: [], //그리드안에 사용여부
		excelDownLoadList: [], //엑셀다운로드시 해더저장
		carTypeNmList: [],
		pagingInfo: {
			currentPage: 1,
			pageUnit: 30,
			totalSize: 0
		}
	};
};

const selectDate1 = (state, { from, to }) => {
	state.searchParams.strtMm01 = from;
	state.searchParams.endMm01 = to;
};

export default {
	...common,
	selectDate1,
	[types.STATE_INIT]: state => {
		Object.assign(state, getInit()); //
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	}
};
